import { apiRequest } from '@scc/lib'
import type {
  FeatureAccessRepository,
  WorkflowResolution,
  FeaturesResponse,
  WorkflowOverrideState,
  StoreStage,
  LifecyclePhase,
} from '@/data/repositories/types'

const base = (agencyId: number, storeId: number) => `/agencies/${agencyId}/stores/${storeId}/features`

/**
 * Raw wire shape. `workflows` is the canonical key (cc-api W2.3); `features` is a
 * back-compat alias of the same array — read whichever is present. `phase`,
 * `tags`, `overrides`, and `assignedStrategistUserId` are optional pending the
 * backend deploy that adds them.
 */
interface RawFeaturesResponse {
  stage?: StoreStage
  phase?: LifecyclePhase
  workflows?: WorkflowResolution[]
  features?: WorkflowResolution[]
  tags?: string[]
  overrides?: Record<string, WorkflowOverrideState>
  assignedStrategistUserId?: string | null
}

/** Exported for direct unit testing. */
export function normalize(raw: RawFeaturesResponse): FeaturesResponse {
  return {
    stage: raw.stage ?? null,
    phase: raw.phase ?? 'prospect',
    workflows: raw.workflows ?? raw.features ?? [],
    tags: raw.tags ?? [],
    overrides: raw.overrides ?? {},
    assignedStrategistUserId: raw.assignedStrategistUserId ?? null,
  }
}

export function createApiFeatureAccessRepository(): FeatureAccessRepository {
  return {
    getFeatures: async (agencyId, storeId) => normalize(await apiRequest<RawFeaturesResponse>(base(agencyId, storeId))),
  }
}
